import apiService from "./api.js";

/**
 * Client service para Monitoramento de Processos por usuário
 * Rotas: /api/process-monitoring/*
 */
export const processMonitoringService = {
  // Monitoramentos
  async getMyMonitorings() {
    return apiService.get("/process-monitoring");
  },

  async createByProcessNumber(numberProcess) {
    return apiService.post("/process-monitoring/by-process", { numberProcess });
  },

  async createFromPublication(publicationId) {
    return apiService.post("/process-monitoring", { publicationId });
  },

  async deleteById(id) {
    return apiService.delete(`/process-monitoring/${id}`);
  },

  async deleteByProcessNumber(numberProcess) {
    return apiService.delete(`/process-monitoring/by-process/${encodeURIComponent(numberProcess)}`);
  },

  // Notificações
  async getMyNotifications({ includeRead = false } = {}) {
    const qs = includeRead ? "?includeRead=true" : "";
    return apiService.get(`/process-monitoring/notifications${qs}`);
  },

  async getUnreadCount() {
    return apiService.get("/process-monitoring/notifications/unread-count");
  },

  async markNotificationRead(id) {
    return apiService.put(`/process-monitoring/notifications/${id}/read`, {});
  },

  async markAllNotificationsRead() {
    return apiService.put("/process-monitoring/notifications/read-all", {});
  },
};
